import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'

const Breadcrumbs = ({ items }) => {
  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1 text-sm mb-4">
      {items.map((item, i) => {
        const isLast = i === items.length - 1
        return (
          <span key={i} className="flex items-center gap-1">
            {i > 0 && <ChevronRight className="w-3.5 h-3.5 text-gray-400" />}
            {isLast || !item.to ? (
              <span className={isLast ? 'font-medium text-gray-900 dark:text-white' : 'text-gray-400'}>
                {item.label}
              </span>
            ) : (
              <Link to={item.to} className="text-gray-400 hover:text-blue-400 transition-colors">
                {item.label}
              </Link>
            )}
          </span>
        )
      })}
    </nav>
  )
}

export default Breadcrumbs
